<template>
  <figure class="video-fig">
    <div class="video-fig__frame">
      <iframe
        :src="`https://www.youtube-nocookie.com/embed/${video.youtubeId}`"
        :title="video.title"
        loading="lazy"
        frameborder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <figcaption class="video-fig__cap">
      <strong>{{ video.title }}</strong>
      <span class="video-fig__meta">{{ video.caption }}</span>
      <span v-if="video.duration" class="video-fig__dur">{{ video.duration }}</span>
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { VIDEOS } from '../data/media';

const props = defineProps<{ videoId: string }>();
const video = computed(() => VIDEOS.find((v) => v.id === props.videoId)!);
</script>

<style scoped>
.video-fig {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.video-fig__frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 6px;
  overflow: hidden;
  background: var(--slate);
  border: 1px solid var(--vein);
}
.video-fig__frame iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.video-fig__cap {
  display: grid;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: var(--slate-soft);
  line-height: 1.5;
}
.video-fig__cap strong {
  color: var(--slate);
  font-family: var(--font-display);
  font-size: 1rem;
  font-weight: 500;
}
.video-fig__meta { font-size: 0.82rem; }
.video-fig__dur {
  font-size: 0.66rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--granite);
}
</style>
